import { Routes } from '@angular/router';
import { adminGuards, canDeactivateGuard } from './admin.guards';

export const administrationRoutes: Routes = [
  {
    path: 'audit',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Audit'
    },
    loadComponent: () => import('./components/audit/audit.component').then(m => m.AuditComponent)
  },
  {
    path: 'backgroundjobs',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Hintergrund Jobs'
    },
    loadComponent: () => import('./components/backgroundjobs/background-jobs.component').then(m => m.BackgroundJobsComponent)
  },
  {
    path: 'backoffice',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Backoffice'
    },
    loadComponent: () => import('./components/backoffice/backoffice.component').then(m => m.BackofficeComponent)
  },
  {
    path: 'capabilities',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Berechtigungen'
    },
    loadComponent: () => import('./components/capabilities/capabilities.component').then(m => m.CapabilitiesComponent)
  },
  {
    path: 'changes',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Änderungsverfolgung'
    },
    loadComponent: () => import('./components/changes/changes.component').then(m => m.ChangesComponent)
  },
  {
    path: 'confidential',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Sicherheitsstufen'
    },
    loadComponent: () => import('./components/confidential/confidential.component').then(m => m.ConfidentialComponent)
  },
  {
    path: 'layout',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Design'
    },
    loadComponent: () => import('./components/layout/layout.component').then(m => m.LayoutComponent)
  },
  {
    path: 'configuration',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Erweiterte Einstellungen'
    },
    loadComponent: () => import('./components/configuration/configuration.component').then(m => m.ConfigurationComponent)
  },
  {
    path: 'configuration-set',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Konfigurationsset'
    },
    loadComponent: () =>
      import('./components/configuration-set/configuration-set.component').then(m => m.ConfigurationSetComponent)
  },
  {
    path: 'decisionstamp',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Beschlussmarkierung'
    },
    loadComponent: () => import('./components/decision-stamp/decision-stamp.component').then(m => m.DecisionStampComponent)
  },
  {
    path: 'emails',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'E-Mails'
    },
    loadComponent: () => import('./components/emails/emails.component').then(m => m.EmailsComponent)
  },
  {
    path: 'exporttemplates',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Exportvorlagen'
    },
    loadComponent: () => import('./components/exporttemplates/exporttemplates.component').then(m => m.ExporttemplatesComponent)
  },
  {
    path: 'interfaces',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Schnittstellen'
    },
    loadComponent: () => import('./components/interfaces/interfaces.component').then(m => m.InterfacesComponent)
  },
  {
    path: 'labels',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Labels'
    },
    loadComponent: () => import('./components/labels/labels.component').then(m => m.LabelsComponent)
  },
  {
    path: 'lists',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Listen'
    },
    loadComponent: () => import('./components/lists/lists.component').then(m => m.ListsComponent)
  },
  {
    path: 'logs',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Logs'
    },
    loadComponent: () => import('./components/logs/logs.component').then(m => m.LogsComponent)
  },
  {
    path: 'mailtemplates',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Mailschablonen'
    },
    loadComponent: () => import('./components/mailtemplates/mailtemplates.component').then(m => m.MailtemplatesComponent)
  },
  {
    path: 'numbergroups',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Nummernkreis'
    },
    loadComponent: () => import('./components/numbergroups/number-groups.component').then(m => m.NumberGroupsComponent)
  },
  {
    path: 'notifications',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Benachrichtigungen'
    },
    loadComponent: () => import('./components/notifications/notifications.component').then(m => m.NotificationsComponent)
  },
  {
    path: 'roles',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Rollen'
    },
    loadComponent: () => import('./components/roles/roles.component').then(m => m.RolesComponent)
  },
  {
    path: 'sse',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Benachrichtigungen'
    },
    loadComponent: () => import('./components/sse/sse.component').then(m => m.SseComponent)
  },
  {
    path: 'templates',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Dokumenttypen'
    },
    loadComponent: () => import('./components/template/template.component').then(m => m.TemplateComponent)
  },
  {
    path: 'triggers',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Trigger'
    },
    loadComponent: () => import('./components/triggers/triggers.component').then(m => m.TriggersComponent)
  },
  {
    path: 'user',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Benutzer'
    },
    loadComponent: () => import('./components/user/user.component').then(m => m.UserComponent)
  },
  {
    path: 'workflows',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Workflows'
    },
    loadComponent: () => import('./components/workflow/workflow.component').then(m => m.WorkflowComponent)
  },
  // Sollte der letzte sein
  {
    path: '**',
    canActivate: [adminGuards()],
    canDeactivate: [canDeactivateGuard()],
    data: {
      breadcrumbLabel: 'Informationen'
    },
    loadComponent: () => import('./components/nebula-info/nebula-info.component').then(m => m.NebulaInfoComponent)
  }
];
